define("shared/components/shared/modal/header", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <header class="o--modalHeader" data-test-id="modal-header" ...attributes>
    {{#if @title}}
      <Shared::Ui::Block class="o--modalHeader__title">
        {{@title}}
      </Shared::Ui::Block>
    {{/if}}
    {{#if (has-block)}}
      {{yield}}
    {{/if}}
  </header>
  */
  {
    "id": "60vQl+JI",
    "block": "[[[11,\"header\"],[24,0,\"o--modalHeader\"],[24,\"data-test-id\",\"modal-header\"],[17,1],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[8,[39,1],[[24,0,\"o--modalHeader__title\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[1,[30,2]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[41,[48,[30,3]],[[[1,\"    \"],[18,3,null],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@title\",\"&default\"],false,[\"if\",\"shared/ui/block\",\"has-block\",\"yield\"]]",
    "moduleName": "shared/components/shared/modal/header.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});